<template>
    <FocusTrap
        :escape-deactivates="false"
        initial-focus="#btn-primary-cta"
        :allow-outside-click="false"
        :active="focusTrapActive"
    >
        <div class="take-tour-dialog">
            <div class="take-tour-dialog-hero-container" />
            <div class="take-tour-dialog-content">
                <h2 class="take-tour-dialog-content-subhead">
                    {{ $t('tourNavRedesign_initDialog_subHeading') }}
                </h2>
                <p>
                    {{ $t('tourNavRedesign_initDialog_description') }}
                </p>
                <p>
                    {{ $t('tourNavRedesign_initDialog_howToOptOut') }}
                </p>
                <div class="take-tour-dialog-content-ctas">
                    <KatButton
                        class="take-tour-dialog-content-ctas-tertiary"
                        variant="secondary"
                        :label="$t('tourNavRedesign_initDialog_ctaSkipTour')"
                        @click="dismissTour"
                        data-test-tag="btn-secondary-cta"
                    />
                    <KatButton
                        id="btn-primary-cta"
                        variant="primary"
                        :label="$t('tourNavRedesign_initDialog_ctaTakeTour')"
                        @click="startTour"
                        data-test-tag="btn-primary-cta"
                    />
                </div>
            </div>
        </div>
    </FocusTrap>
</template>

<script>
import KatButton from '../../katal/KatButton.vue';
import { mapActions } from 'pinia';
import { REDESIGN_TOUR_STEPS, useNavRedesignTourStore } from '../../../stores/navRedesignTourStore';
import { FocusTrap } from 'focus-trap-vue';

export default {
    name: 'TakeTourDialog',
    components: { FocusTrap, KatButton },
    data() {
        return {
            focusTrapActive: false,
        };
    },
    mounted() {
        this.focusTrapActive = true;
        this.$metrics
            .newChildActionPublisherForMethod('RedesignFlyoutImpression')
            .publishCounterMonitor('impression', 1);
    },
    methods: {
        ...mapActions(useNavRedesignTourStore, ['deferTour', 'setTourStep']),
        dismissTour() {
            this.$metrics.newChildActionPublisherForMethod('RedesignFlyoutDismiss').publishCounterMonitor('click', 1);
            this.deferTour(REDESIGN_TOUR_STEPS.TOUR_FINISHED);
        },
        startTour() {
            this.$metrics.newChildActionPublisherForMethod('RedesignFlyoutStartTour').publishCounterMonitor('click', 1);
            this.setTourStep(REDESIGN_TOUR_STEPS.STEP_1_NAV_MENU);
        },
    },
};
</script>

<style lang="scss" scoped>
.take-tour-dialog {
    width: 320px;

    &-hero-container {
        background-image: url('../../../../images/compass-illustration.svg');
        background-size: contain;
        height: 240px;
    }

    &-content {
        padding: 16px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background: $kat-white;

        &-subhead {
            align-self: stretch;
            color: $nordic;
            font-size: 20px;
            margin: 0;
        }

        p {
            color: $nordic;
            margin: 0;
            line-height: 15px;
            padding-top: 12px;
        }

        &-ctas {
            padding-top: 16px;
            width: 100%;
            display: flex;
            justify-content: flex-end;
            font-weight: unset;

            &-tertiary {
                background-color: unset;
                border-color: transparent;
                box-shadow: none;
                color: $eastern;
            }
        }
    }
}
</style>
